export enum PortfolioIds {
  RA_CAPITAL = 1,
  BLACKWELL = 10,
  NEXUS = 11,
  HONG_KONG_SHORT_BASKET = 12,
  NEXUS_2 = 13,
  NEXUS_3 = 14
}
